/**
 * @file chips-choice.component.tsx
 * @description Form-control обертка для работы с UI ChipsChoice компонентом в react-hook-form
 * @author AI-Generated | Human-Reviewed
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [react, react-hook-form, @src/components/ui/editors/chips-choice]
 * @related-files [@src/components/ui/editors/chips-choice/chips-choice.component.tsx]
 */

import { ChipsChoice as UIChipsChoice } from '@src/components/ui/editors/chips-choice';
import { Control, Controller } from 'react-hook-form';

/**
 * Props для form-control компонента ChipsChoice с интеграцией react-hook-form
 */
interface IChipsChoice extends Omit<React.ComponentProps<typeof UIChipsChoice>, 'onChange' | 'value'> {
    /** Control объект из react-hook-form для управления формой */
    control: Control;
    /** Имя поля в форме */
    name: string;
}

export const ChipsChoice = ({ control, name, ...props }: IChipsChoice) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => <UIChipsChoice value={field.value} {...props} onChange={field.onChange} />}
        />
    );
};
